'use strict';
import classNames from 'classnames';
import React from 'react';
import * as T from 'prop-types';
import {ListItem} from '../../../components/lists/ListItem';
import {getFileRequirementMetrics} from '../TaskItem';


export function TemplateTaskItemView(props) {
  const model = props.model;
  const name = model.name;
  const description = model.description;
  const fileCountLabel = getFileRequirementMetrics(model.metrics);

  return (
    <ListItem
      className={classNames("TaskCard TaskCard_template", props.className)}
      bindParam={model}
      onClick={props.onClick}
      onContextMenu={props.onContextMenu}
    >
      <div className="card">
        <div className="TaskCard__body">
          <div className="TaskCard__nameArea">
            <span>
              {name}
            </span>
            <div className="task-card-description">
              <span title={description}>
                {description}
              </span>
            </div>
          </div>

          <i className="TaskCard__navIcon icon ion-chevron-right" />
        </div>

        <div className="TaskCard__stats">
          <div className="TaskCard__metrics">
            <div className="TaskCard__metrics__container">
              <i className="icon ion-ios-folder-outline" />
              <span className="TaskCard__metrics__label">
                {fileCountLabel}
              </span>
            </div>
            {/* <div className="TaskCard__metrics">
              <div className="TaskCard__metrics__container">
                <i className="icon ion-ios-list-outline"/>
                <span className="TaskCard__metrics__label">
                {props.formCountLabel}
              </span>
              </div>
            </div>*/}
          </div>
        </div>
      </div>
    </ListItem>
  );
}

TemplateTaskItemView.propTypes = {
  className: T.string,
  model: T.object.isRequired,

  onClick: T.func.isRequired,
  onContextMenu: T.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/tasks/components/TemplateTaskItem/TemplateTaskItemView.js